/* src/app/features/player/components/player-skip-intro/player-skip-intro.component.scss */
.skip-intro {
  pointer-events: all;
  position: relative;
  z-index: 2;
  display: block;
  margin: 0 40px 12px auto;
  padding: 12px 28px;
  font-size: 18px;
  font-weight: 600;
  color: var(--text_primary);
  background: var(--background_primary_8);
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
.skip-intro:hover {
  background: var(--background_primary_7);
}
/*# sourceMappingURL=player-skip-intro.component.css.map */
